import script from "./TaskStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskStatus.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&lang=css&external"
import "./TaskStatus.vue?vue&type=style&index=1&id=6aa5a84c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa5a84c"]])

export default __exports__